import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { VimeoVideoCard } from './VimeoVideoCard';

const useStyles = makeStyles({
  grid: {
    overflowY: 'auto',
    flex: 1,
    padding: '8px',
  },
  zeroState: {
    padding: 16,
    color: '#667085',
    textAlign: 'center',
  },
});

export const VimeoVideoGrid = ({ results, selectedVideo, onSelect, query }) => {
  const classes = useStyles();

  if (results.length === 0 && query.length >= 3) {
    return (
      <Typography className={classes.zeroState}>
        {`No videos found for '${query}'.`}
      </Typography>
    );
  }

  return (
    <div className={classes.grid}>
      <Grid container spacing={1}>
        {results.map((video) => (
          <Grid item xs={4} key={video.id}>
            <VimeoVideoCard
              video={video}
              isSelected={video.id === selectedVideo?.id}
              onSelect={onSelect}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

VimeoVideoGrid.defaultProps = {
  results: [],
  selectedVideo: null,
  onSelect: () => {},
  query: '',
};
